import commonHelper from '@/app/utility/common.helper.utility';
import DatePicker from 'vue2-datepicker';
import addEditTenantRecovery from './addEditTenantRecovery';
import recoveryDetails from './recoveryDetails';
import advanceSearch from './advanceSearch';
import { ModelSelect } from 'vue-search-select';

export default {
  name: 'tenantRecovery',
  components: {
    addEditTenantRecovery,
    recoveryDetails,
    advanceSearch,
    DatePicker,
    ModelSelect
  },
  watch: {
    currentPage: function() {
      this.getRecoveryList();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getRecoveryList();
    },
    selectAllCheckBox: function() {
      this.checkUncheckAll();
    }
  },
  data() {
    return {
      payload: null,
      showAlert: false,
      isSuccess: false,
      selectAllCheckBox: false,
      showRecoveryDetailModal: false,
      showValueSetModal: false,
      unsubscribe: null,
      tenantRecoveryRowDetail: null,
      showAddRecoveryModal: false,
      showAdvSearchModal: false,
      loader: false,
      unitDisplay: null,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      totalRows: null,
      currentPage: 1,
      searchParams: null,
      leaseUnitRowDetails: null,
      recoveryType: {
        value: null,
        text: null
      },
      batchName: null,
      prj_type: {
        value: null,
        text: null
      },
      prj_type_list: [
        {
          value: 'fms_unit',
          text: 'FMS Unit'
        },
        {
          value: 'fms_sub_unit',
          text: 'FMS Sub Unit'
        }
      ],
      gridData: [],
      gridFields: [
        {
          key: 'selectBox',
          label: 'Select',
          stickyColumn: true,
          variant: 'primary'
        },
        {
          key: 'lease_prj_name',
          label: 'Lease Project'
        },
        {
          key: 'location_name',
          label: 'Location'
        },
        {
          key: 'trx_type'
        },
        {
          key: 'recovery_basis_meaning',
          label: 'Recovery Basis'
        },
        {
          key: 'schedule_type_vset_meaning',
          label: 'Schedule Type'
        },
        {
          key: 'recovery_type_vset_meaning',
          label: 'Recovery Type'
        },
        {
          key: 'batch_date'
        },
        {
          key: 'batch_name',
          label: 'Batch No.'
        },
        {
          key: 'batch_description'
        },
        {
          key: 'line_description'
        },
        {
          key: 'period_from',
          label: 'From Date'
        },
        {
          key: 'period_to',
          label: 'To Date'
        },
        {
          key: 'recovery_rate_uom_vset_meaning',
          label: 'Recovery Rate UOM'
        },
        {
          key: 'recovery_rate'
        },
        {
          key: 'charge_ac_ccid_dtl',
          label: 'Charge Account'
        },
        {
          key: 'debtor_ac_ccid_dtl',
          label: 'Debtor Account'
        },
        {
          key: 'category_name',
          label: 'Tax Category'
        },
        {
          key: 'sac_code',
          label: 'SAC Code'
        },
        {
          key: 'hsn_code',
          label: 'HSN Code'
        },
        {
          key: 'batch_status_vset_meaning',
          label: 'Status'
        }
      ]
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'add') {
          this.showAddRecoveryModal = true;
          this.tenantRecoveryRowDetail = null;
        }
        if (actionName === 'download' && !this.showAddRecoveryModal) {
          this.loader = true;
          /**
           * @param(payload, 'action name', 'file name')
           */
          const downloadpayload = { ...this.payload };
          downloadpayload._limit = this.totalRows;
          this.downloadExcel.downloadData(
            downloadpayload,
            'leaseRecovery/getTenantRecovery',
            'tenant-recovery',
            () => (this.loader = false)
          );
        }
      }
    });
  },
  methods: {
    getRecoveryList() {
      if (!this.searchParams) {
        this.payload = {
          _page: this.currentPage - 1,
          _limit: this.perPage,
          recovery_type_vset: this.recoveryType.value,
          batch_name: this.batchName
        };
      } else {
        this.payload = {
          _page: this.currentPage - 1,
          _limit: this.perPage
        };
        Object.assign(this.payload, this.searchParams);
      }
      this.loader = true;
      this.$store
        .dispatch('leaseRecovery/getTenantRecovery', this.payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.gridData = response.data.data.page.map(data => {
              data.selectBox = false;
              return data;
            });
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (this.vsetCode === 'LEASE_RECOVERY') {
        this.recoveryType.text = item.value_meaning;
        this.recoveryType.value = item.value_code;
      }
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    mainSearch() {
      this.searchParams = null;
      this.getRecoveryList();
    },
    clearParam() {
      this.recoveryType.text = null;
      this.recoveryType.value = null;
      this.batchName = null;
      this.gridData = [];
      this.totalRows = null;
      this.currentPage = 1;
    },
    advanceSearch(params) {
      this.searchParams = params;
      this.getRecoveryList();
      this.showHideAdvSearchModal(false);
    },
    rowSelected(item) {
      this.tenantRecoveryRowDetail = item;
      this.showRecoveryDetailModal = true;
    },
    showHideRecoveryModal(flag) {
      this.showAddRecoveryModal = flag;
    },
    showHideRecoveryDetailsModal(flag) {
      this.showRecoveryDetailModal = flag;
    },
    showHideAdvSearchModal(flag) {
      this.showAdvSearchModal = flag;
    },
    checkUncheckAll() {
      this.gridData = this.gridData.map(data => {
        data.selectBox = this.selectAllCheckBox;
        return data;
      });
    },
    selectBoxChecked(flag, index) {
      this.gridData[index].selectBox = flag;
    },

    clearVsetValues(vsetCode) {
      if (vsetCode === 'LEASE_RECOVERY') {
        this.recoveryType.text = null,
        this.recoveryType.value = null
      }
    }
  },
  beforeDestroy() {
    this.unsubscribe();
    this.$store.dispatch('leaseRecovery/saveAdvSearchFilters', null);
    // this.$store.state.leaseRecovery.leaseRecovery.adv_search = null;
  }
};
